<template>
  <div class="block">
    <div class="block-title">POI专属</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="券管理" name="synchronous">
        <DyPoiCouponSynchronous ref="synchronousRef" />
      </el-tab-pane>
      <el-tab-pane label="券使用情况" name="couponDyPoiDetail">

      </el-tab-pane>
    </el-tabs>
    <couponDyPoiDetail v-if="activeName === 'couponDyPoiDetail'" ref="couponDyPoiDetailRef" />
  </div>
</template>
<script>
import DyPoiCouponSynchronous from "./DyPoiCouponSynchronous.vue";
import couponDyPoiDetail from "./component/couponDyPoiDetail.vue";
export default {
  components: {
    DyPoiCouponSynchronous,
    couponDyPoiDetail
  },
  data() {
    return {
      activeName: "synchronous",
      agentName: "",
    };
  },
  mounted() {

  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      if(tab.name === 'synchronous'){
        this.$refs.synchronousRef.reset();
      }else if(tab.name === 'couponDyPoiDetail'){
        // this.$refs.couponDyPoiDetailRef.reset();
      }
      console.log(tab.name, event, "ee");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDyPoiNew/index.vue